import {
  appManagedWalletConnector,
  KNOWN_CONNECTOR_IDS,
} from '@vertex-protocol/react-client';
import { getIsLocalTestWalletShortcutEnabled } from 'client/hooks/ui/localTestWalletShortcut';
import { useEffect } from 'react';
import { Connector, useConfig, useConnect } from 'wagmi';

const appManagedWalletConnectorFn = appManagedWalletConnector({
  id: KNOWN_CONNECTOR_IDS.customWallet,
});

function hasCustomWalletConnector(connectors: readonly Connector[]) {
  return connectors.some(
    (connector) => connector.id === KNOWN_CONNECTOR_IDS.customWallet,
  );
}

export function useRegisterAppManagedWalletConnector() {
  const config = useConfig();
  const { connectors } = useConnect();

  useEffect(() => {
    if (!getIsLocalTestWalletShortcutEnabled()) {
      return;
    }

    if (hasCustomWalletConnector(connectors)) {
      return;
    }

    // Privy's wagmi config filters initial connectors; keep the app-managed
    // connector available for the existing hidden custom-wallet workflow.
    config._internal.connectors.setState((currentConnectors) => {
      if (hasCustomWalletConnector(currentConnectors)) {
        return currentConnectors;
      }

      return [
        ...currentConnectors,
        config._internal.connectors.setup(appManagedWalletConnectorFn),
      ];
    });
  }, [config, connectors]);
}
